import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CalcApi } from 'src/app/models/onlinecalc/calc-api.model';
import { CalcDetails } from 'src/app/models/onlinecalc/calc-details.model';
import { CalcRunCtrl } from 'src/app/models/onlinecalc/calc-run-ctrl.model';
import { CalcRunId } from 'src/app/models/onlinecalc/calc-run-id.model';
import { CommPlanJson } from 'src/app/models/onlinecalc/comm-plan-json.model';
import { RunCalcJson } from 'src/app/models/onlinecalc/run-calc-json.model';
import { RunCalcResponce } from 'src/app/models/onlinecalc/run-calc-responce.model';
import { SalesChannelModel } from 'src/app/models/onlinecalc/sales-channel-model.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { CommissionService } from 'src/app/service/commission.service';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';
import { OnlineCalcService } from 'src/app/service/onlinecalc.service';

@Component({
  selector: 'app-add-calc-run',
  templateUrl: './add-calc-run.component.html',
  styleUrls: ['./add-calc-run.component.css']
})

export class AddCalcRunComponent implements OnInit {

  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  filteredCalRunCtrlModel: CalcRunCtrl[] = [];
  calRunData: CalcRunCtrl[] = [];
  headder: string = 'Add Run Control Details';
  actionButtons: any;
  calcRunCtrlModel = new CalcRunCtrl();
  IsmodelShow: boolean = false;
  commData: CommPlan[] = [];
  salesChannels: string[] = [];
  myModelProperty: any;
  calRunIdsData: CalcRunCtrl[] = [];
  getEdate: CalcRunCtrl[] = [];
  commPlansList: CalcRunCtrl[] = [];
  empIdList: CalcRunCtrl[] = [];
  calcRunCtrlModels: CalcRunCtrl[] = [];
  dupcalcRunCtrlModels: CalcRunCtrl[] = [];
  filteredCalcctrl: CalcRunCtrl[] = [];
  inprogressCalRunIds: CalcRunCtrl[] = [];
  calcRunCtrlModelsData: CalcRunCtrl[] = [];
  labelColumn: TableColumn[];
  selectedCalRun = new CalcRunCtrl();
  show: boolean = true;
  checked: boolean = false;
  buttonShow: boolean = true;
  id: string = '';
  runCalc = new RunCalcJson();
  calRunIdList: CalcRunId[] = [];
  calRunIds: any;
  checkSc: boolean = true;
  disable: boolean = false;
  calcApi = new CalcApi();
  controlComPlan = new FormControl();
  filteredCommStrValues: Observable<CalcRunCtrl[]> | undefined;
  ipCalrunIdList: any = [];
  lenth: number = 0;
  runCalcRes: CalcDetails[] = [];
  resHeadder: string = '';
  errorMessage: string = '';
  isAccessDisabled: boolean = false;
  runCtrlId: number = 0;
  validFromDt: any;

  constructor(private notificationService: NotificationService, private httpService: HttpClient,
    private onlineCalcService: OnlineCalcService, private router: Router, private route: ActivatedRoute,
    private commissionService: CommissionService, private authGaurdService: AuthGaurdService,
    private globalService: GlobalService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.id = params['page'];
      console.log('page', this.id);
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });

    this.isAccessDisabled = this.globalService._permissionCheck('user-control');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
    this.init()
  }

  init() {
    this.runCalcRes = [];
    //this.calcRunCtrlModels = [];
    this.calRunIdList = [];
    this.getAllCommPlans();


    this.onlineCalcService.selectedCalRun = JSON.parse(localStorage.getItem("selectedCalRun"));

    console.log(this.onlineCalcService.selectedCalRun);
    console.log(this.onlineCalcService.selectedCalRun.runCtrlId);

    if (this.onlineCalcService.selectedCalRun?.runCtrlId) {
      this.getCalRunByRunId(this.onlineCalcService.selectedCalRun.runCtrlId);
    }

    if (this.id === 'update') {
      this.buttonShow = false;
      this.headder = 'Update Run Control Details';
    } else {
      this.buttonShow = true;
    }

  }

  getAllCommPlans() {
    console.log("getAllCommPlans called");
    this.commissionService.getAllCommPlans()
      .subscribe((data: CommPlan[]) => {
        this.commData = data;
        this.getSalesChannels();
        this.getCalRunIDsBySalesChnl();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    this.calcRunCtrlModel.created_by = this.authGaurdService.loginUser();
    this.calcRunCtrlModel.created_dt = new Date();
    this.calcRunCtrlModels.push(this.calcRunCtrlModel);

  }

  getCalRunByRunId(runCtrlId: number) {
    console.log("getCalRunByRunId() called");
    this.onlineCalcService.getCalRunByRunId(runCtrlId).subscribe(
      (response: CalcRunCtrl[]) => {
        this.calcRunCtrlModels = [];
        this.calcRunCtrlModels = response;
        //console.log(this.calcRunCtrlModels);
        this.loadData();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  loadData() {
    console.log("loadData called");
    console.log(this.calcRunCtrlModels);
    this.calcRunCtrlModel.run_control_name = this.calcRunCtrlModels[0].run_control_name;
    this.calcRunCtrlModel.description = this.calcRunCtrlModels[0].description;
    this.calcRunCtrlModel.calendar_type = this.calcRunCtrlModels[0].calendar_type;


    if (this.calcRunCtrlModels[0].run_all_open_flg != 'Y') {
      if (this.calcRunCtrlModels[0].saleschannel) {
        this.calcRunCtrlModel.saleschannel = this.calcRunCtrlModels[0].saleschannel;
        this.selectedComm();
      }
      console.log(this.calcRunCtrlModels[0].cal_run_id);
      this.calcRunCtrlModel.cal_run_id = this.calcRunCtrlModels[0].cal_run_id.split(',');
      //console.log(this.calcRunCtrlModel.cal_run_id);
      if (this.calcRunCtrlModels[0].saleschannel)
        this.calcRunCtrlModel.saleschannel = this.calcRunCtrlModels[0].saleschannel.split(',');
      this.calcRunCtrlModel.runCtrlId = this.calcRunCtrlModels[0].runCtrlId;
      console.log(this.calcRunCtrlModel.runCtrlId);
    }

    if (this.calcRunCtrlModels[0].run_all_open_flg === 'Y') {
      this.show = false;
      this.checked = true;
    }
  }

  public createRunCtrl(event: string) {
    console.log("createRunCtrl called");
    if (this.filteredCalcctrl.length > 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Remove The Duplicate CommPlan');
    } else {
      if (this.calcRunCtrlModel.run_control_name && this.calcRunCtrlModel.description) {
        //console.log(JSON.stringify(this.calcRunCtrlModels));

        for (let calrunModl of this.calcRunCtrlModels) {

          console.log(calrunModl.cal_run_id);

          calrunModl.runCtrlId = 0;

          if (calrunModl.saleschannel)
            calrunModl.saleschannel = calrunModl.saleschannel.toString();
          if (calrunModl.cal_run_id)
            calrunModl.cal_run_id = calrunModl.cal_run_id.toString();
          if (calrunModl.sc_emp_id)
            calrunModl.sc_emp_id = calrunModl.sc_emp_id.toString();
          if (calrunModl.comm_plan_id) {
            calrunModl.comm_plan_id = calrunModl.comm_plan_id;
            console.log(calrunModl.comm_plan_id);
          }

          calrunModl.description = this.calcRunCtrlModel.description.toString();

        }

        console.log(JSON.stringify(this.calcRunCtrlModels));
        this.onlineCalcService.saveRunCtrl(this.calcRunCtrlModels)
          .subscribe((response: CalcRunCtrl[]) => {
            console.log(JSON.stringify(response));
            this.calcRunCtrlModels[0].runCtrlId = response['runCtrlId'];
            console.log(this.calcRunCtrlModels);

            console.log(response['runCtrlId']);

            if (response) {
              if (event === 'SaveRun') {
                console.log("Inside IF SaveRun");
                this.runCtrlJson();
              } else {
                this.notificationService.sendNotification(NotificationType.SUCCESS, `Submitted Successfully`);
                this.router.navigate(['/user-control']);
              }
            } else
              this.notificationService.sendNotification(NotificationType.ERROR, 'Something went wrong');
          },
            (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            })

      } else
        this.notificationService.sendNotification(NotificationType.ERROR, 'Enter the mandatory fields');
    }
  }

  public updateRunCtrl(event: string) {
    console.log("updateRunCtrl called");

    console.log(this.onlineCalcService.selectedCalRun.runCtrlId);

    if (this.filteredCalcctrl.length > 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Remove The Duplicate CommPlan');
    } else {
      console.log(this.calcRunCtrlModel);
      if (this.calcRunCtrlModel.run_control_name && this.calcRunCtrlModel.description) {
        if (this.calcRunCtrlModel.run_all_open_flg === 'Y') {
          this.calcRunCtrlModels = [];
          this.calcRunCtrlModel.saleschannel = null;
          this.calcRunCtrlModel.cal_run_id = null;
          this.calcRunCtrlModel.comm_plan_id = null;
          this.calcRunCtrlModels.push(this.calcRunCtrlModel);
        } else {
          console.log("Inside else = " + JSON.stringify(this.calcRunCtrlModels));
          for (let calrunModl of this.calcRunCtrlModels) {
            calrunModl.run_control_name = this.calcRunCtrlModel.run_control_name;
            calrunModl.description = this.calcRunCtrlModel.description;

            if (this.calcRunCtrlModel.saleschannel)
              calrunModl.saleschannel = this.calcRunCtrlModel.saleschannel.toString();

            if (this.calcRunCtrlModel.cal_run_id)
              calrunModl.cal_run_id = this.calcRunCtrlModel.cal_run_id.toString();

            calrunModl.runCtrlId = this.onlineCalcService.selectedCalRun.runCtrlId;//this.calcRunCtrlModels[0].runCtrlId;

            if (calrunModl.sc_emp_id)
              calrunModl.sc_emp_id = calrunModl.sc_emp_id.toString();

            calrunModl.updated_by = this.authGaurdService.loginUser();
            calrunModl.updated_dt = new Date();
          }
        }
        //console.log(this.calcRunCtrlModels.length);
        console.log("=====" + JSON.stringify(this.calcRunCtrlModels));
        this.onlineCalcService.updateRunCtrl(this.calcRunCtrlModels)
          .subscribe(response => {
            response = response as ErrorResponseMessage;

            //console.log(' updateRunCtrl resp === ', response);
            if (response) {

              if (event === 'UpdateRun') {
                this.runCtrlJson();
              } else {
                this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
                this.router.navigate(['/user-control']);
              }

              this.init();
            } else {
              this.notificationService.sendNotification(NotificationType.ERROR, 'Something Went Wrong');
            }
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      } else
        this.notificationService.sendNotification(NotificationType.ERROR, 'Enter the mandatory fields Like Run Control Name  and Run Control Description');
    }
  }

  private runCtrlJson() {
    console.log("runCtrlJson called");
    // console.log(this.calcRunCtrlModels);
    if (this.calcRunCtrlModels.length > 0) {
      if (this.calcRunCtrlModels[0].run_all_open_flg != 'Y') {
        const calrunIds = this.calcRunCtrlModels[0].cal_run_id.toString().split(',');
        for (let runId of calrunIds) {
          const runCalcModel = new CalcRunId();
          runCalcModel.calRunId = runId;
          if (this.calcRunCtrlModels[0].saleschannel) {
            for (let sc of this.calcRunCtrlModels[0].saleschannel.toString().split(',')) {
              const scModel = new SalesChannelModel();
              scModel.salesChanl = sc;
              this.checkSc = true;

              for (let commPlanData of this.commPlansList) {
                for (let calrunModl of this.calcRunCtrlModels) {
                  const commPlanJson = new CommPlanJson();
                  let salcnl = null;

                  if (commPlanData.comm_plan_id == calrunModl.comm_plan_id) {
                    salcnl = commPlanData.commPlan.split(' - ')[0];
                  }

                  if (salcnl != null && sc === salcnl) {
                    this.checkSc = false;
                    commPlanJson.commPlanId = calrunModl.comm_plan_id;

                    if (calrunModl.sc_emp_id)
                      commPlanJson.scEmpId = calrunModl.sc_emp_id.toString().split(',');//b;
                    scModel.commPlanIds.push(commPlanJson);
                  }

                }
              }// for close
              runCalcModel.salesChanls.push(scModel);
            }
          }
          this.calRunIdList.push(runCalcModel);
        }
      }
    }

    this.runCalc.openFlag = this.calcRunCtrlModels[0].run_all_open_flg;
    this.runCalc.runCtrlId = this.calcRunCtrlModels[0].runCtrlId;
    // HOA-8442: the engine token is obtained server-side by the Java proxy; the browser no
    // longer sends one.
    this.runCalc.token = null;
    this.runCalc.userName = this.authGaurdService.loginUserName;
    this.runCalc.CalcRunModel = this.calRunIdList;
    this.calcApi.trigger_json = JSON.stringify(this.runCalc);
    this.calcApi.created_by = this.authGaurdService.loginUser();
    this.calcApi.created_dt = new Date();

    console.log(this.runCalc);

    this.onlineCalcService.saveCalcJson(this.runCalc).subscribe(
      (response: RunCalcResponce) => {
        console.log(JSON.stringify(response));
        if (response.status === 'Successful') {
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Run Successfully Started`);
          console.log("Inside IF");
          this.errorMessage = '';
          this.resHeadder = 'Calc Response Of UID : ';
          this.resHeadder = this.resHeadder + response.uid;
          this.initializeColumns();
          this.runCalcRes = response.details;
        } else {
          console.log("Inside ELSE");
          this.errorMessage = response.status + "  Due to " + response.message;
          this.notificationService.sendNotification(NotificationType.ERROR, this.errorMessage);
        }
      },
      (errorResponse: HttpErrorResponse) => {
        this.errorMessage = "Run Failed. Unable to start the calc.";
        this.notificationService.sendNotification(NotificationType.ERROR, this.errorMessage);
      }
    )
  }




  redirect(url: string) {
    this.router.navigate(['/' + url]);

  }

  filterCommStr() {
    this.filteredCommStrValues = this.controlComPlan.valueChanges.pipe(
      startWith(''),
      map(value => this._filterStr(value))
    );
  }
  private _filterStr(value: string): CalcRunCtrl[] {
    const filterValue = this._normalizeValue(value);
    return this.commPlansList.filter(item => this._normalizeValue(item.commPlan).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    let result = '';
    if (value)
      result = value.toString().toLowerCase().replace(/\s/g, '');
    return result;
  }



  getCommPlans(salesChannels: string) {
    console.log("getCommPlans called");
    if (salesChannels.length > 0) {
      this.onlineCalcService.getCommPlans(salesChannels).subscribe(
        (response: CalcRunCtrl[]) => {
          this.commPlansList = response;
          console.log(this.commPlansList);
          console.log(this.calcRunCtrlModels);
          if (this.calcRunCtrlModels.length > 0 && this.commPlansList.length > 0) {
            this.dupcalcRunCtrlModels = [];
            this.dupcalcRunCtrlModels = JSON.parse(JSON.stringify(this.calcRunCtrlModels));
            this.calcRunCtrlModels = [];
            this.dupcalcRunCtrlModels.forEach((calcRunCtrl: CalcRunCtrl, index: any) => {
              this.commPlansList.some((commPlan: CalcRunCtrl, index: any) => {
                if (calcRunCtrl.comm_plan_id == commPlan.comm_plan_id) {
                  this.calcRunCtrlModels.push(calcRunCtrl);
                }
              })
            });
            if (this.calcRunCtrlModels.length == 0) {
              console.log(this.calcRunCtrlModel);
              this.calcRunCtrlModels.push(this.calcRunCtrlModel);
            }
          }
          this.getCalRunData();
          this.filterCommStr();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
    else {
      this.commPlansList = [];
    }
  }



  getSalesChannels() {
    console.log("getSalesChannels called");
    for (let comm of this.commData) {
      if (comm.sales_channel_desc) {
        this.salesChannels.push(comm.sales_channel_desc);
      }
    }
    this.salesChannels = this.salesChannels.sort((a, b) => (a < b) ? -1 : 1);
    this.salesChannels = this.salesChannels.filter((v, i) => this.salesChannels.findIndex(item => item == v) === i);

  }


  getCalRunIDsBySalesChnl() {
    console.log("getCalRunIDsBySalesChnl called");
    this.onlineCalcService.getCalRunIDsBySalesChnl().subscribe(
      (response: CalcRunCtrl[]) => {
        this.calRunIdsData = response;
        //console.log(JSON.stringify(response));
        this.calRunIdsData = this.calRunIdsData.sort((a: any, b: any) => b.cal_run_id - a.cal_run_id);
        this.calRunIdsData = Array.from(
          new Map(this.calRunIdsData.map((item: any) => [item.cal_run_id, item])).values()
        ).sort((a: any, b: any) => b.cal_run_id - a.cal_run_id);
        //this.getEdate = JSON.parse(JSON.stringify(this.calRunIdsData));
        console.log(this.calRunIdsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }


  getCommPlan(event: any, index: number) {
    //console.log("getCommPlan called");
    if (this.lenth === this.calcRunCtrlModels.length) {
      this.disable = false;
    }
    this.lenth = this.calcRunCtrlModels.length;
    this.filteredCalcctrl = [];
    this.dupcalcRunCtrlModels = [];

    this.dupcalcRunCtrlModels = JSON.parse(JSON.stringify(this.calcRunCtrlModels));
    this.dupcalcRunCtrlModels.pop();
    this.filteredCalcctrl = this.dupcalcRunCtrlModels.filter((calcCtrl) => (calcCtrl.comm_plan_id == event.target.value));

    if (this.filteredCalcctrl.length > 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, "The CommPlan is Already Exist  Please Select Diffrent CommPlan or Remove ");
      this.disable = true;
    }
    //console.log(this.calcRunCtrlModels[0].comm_plan_id);
    // console.log(this.calcRunCtrlModel.cal_run_id[0]);

    this.getEdate = this.calRunIdsData.filter(comm => comm.cal_run_id === this.calcRunCtrlModel.cal_run_id[0]);
    //console.log(this.getEdate);
    this.getEdate = this.getEdate.sort((a, b) => (a.valid_from_dt < b.valid_from_dt) ? -1 : 1);
    //console.log(this.getEdate);

    for (let vdate of this.getEdate) {
      // console.log(vdate.valid_from_dt);
      this.validFromDt = vdate.valid_from_dt;
    }

    if (this.calcRunCtrlModels[0].comm_plan_id !== "") {
      this.getEmpIDList(event.target.value, index, this.validFromDt);
    } else {
      this.getEmpIDList(999999, 0, '1900-01-01');
    }

  }

  getEmpIDList(commPlanId: number, i: number, validFromDt: any) {
    console.log("getEmpIDList called");
    console.log(commPlanId);
    console.log(validFromDt);
    console.log(i);
    this.onlineCalcService.getEmpIdByCommIdList(commPlanId, validFromDt).subscribe(
      (response: CalcRunCtrl[]) => {
        this.calcRunCtrlModels[i].empIdList = response;

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  getIDList(commPlanId: number, calcRunMdl: CalcRunCtrl, cal_run_id: any) {
    console.log("getIDList called");
    this.onlineCalcService.getEmpIdList(commPlanId, cal_run_id).subscribe(
      (response: CalcRunCtrl[]) => {
        calcRunMdl.empIdList = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
  }

  loadScEmpId() {
    console.log("loadScEmpId called");
    for (let calcMdl of this.calcRunCtrlModels) {
      console.log(calcMdl.cal_run_id);
      if (calcMdl.comm_plan_id)
        this.getIDList(calcMdl.comm_plan_id, calcMdl, calcMdl.cal_run_id);
      if (calcMdl.sc_emp_id)
        calcMdl.sc_emp_id = calcMdl.sc_emp_id.split(',');
    }
  }

  selectedComm() {
    console.log("selectedComm called");

    if (this.calcRunCtrlModel.saleschannel.length === 1 && this.calcRunCtrlModels.length === 0)
      this.calcRunCtrlModels.push(this.calcRunCtrlModel);
    else if (this.calcRunCtrlModel.saleschannel.length === 0)
      this.calcRunCtrlModels = [];
    this.getCommPlans(this.calcRunCtrlModel.saleschannel);
  }

  addNewRow() {
    console.log("addNewRow called");
    const calcRunCtrlModl = new CalcRunCtrl();
    calcRunCtrlModl.run_control_name = this.calcRunCtrlModel.run_control_name;
    calcRunCtrlModl.description = this.calcRunCtrlModel.description;
    calcRunCtrlModl.cal_run_id = this.calcRunCtrlModel.cal_run_id;
    calcRunCtrlModl.saleschannel = this.calcRunCtrlModel.saleschannel;
    calcRunCtrlModl.created_by = this.calcRunCtrlModel.created_by;
    calcRunCtrlModl.created_dt = this.calcRunCtrlModel.created_dt;
    this.calcRunCtrlModels.push(calcRunCtrlModl);
    console.log("this.calcRunCtrlModels = " + JSON.stringify(this.calcRunCtrlModels));

  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  public removeRow(index: any) {
    console.log("removeRow() called");
    console.log(this.calcRunCtrlModels[index])
    if (this.calcRunCtrlModels.length > 1) {
      if (this.calcRunCtrlModels[index].id != null) {
        this.removeFilterData(index);
        this.deleteCommPlan(this.calcRunCtrlModels[index].id, index);
      }
      else {
        this.removeFilterData(index);
        this.calcRunCtrlModels.splice(index, 1);

      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete You Can Add Or Update The Row.");
    }
    this.disable = false;
  }

  private removeFilterData(i: any) {
    console.log("removeFilterData() called");
    if (this.filteredCalcctrl.length > 0) {
      const comPlanId = this.calcRunCtrlModels[i].comm_plan_id;
      this.filteredCalcctrl.forEach((value: any, index: any) => {
        if (value.comm_plan_id == comPlanId)
          this.filteredCalcctrl.splice(index, 1);
      })
    }
  }


  public deleteCommPlan(id: number, i: number): void {
    console.log("deleteCommPlan() called");
    if (confirm("Are you sure to delete this Record")) {
      this.onlineCalcService.deleteCommPlan(id).subscribe(
        (response: CustomHttpRespone) => {
          this.calcRunCtrlModels.splice(i, 1);
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          //this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    }
  }

  check(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }
  checkCom(name: string): boolean {
    if (name === 'Commission Plan')
      return true;
    else
      return false;
  }



  getCalRunData() {
    console.log("getCalRunData() called");
    this.calcRunCtrlModelsData = JSON.parse(JSON.stringify(this.calcRunCtrlModels));
    this.calcRunCtrlModels = [];
    this.calcRunCtrlModels = this.calcRunCtrlModelsData;
    this.loadScEmpId();
  }


  checkEmp(name: string): boolean {
    if (name === 'Emp Name/ID')
      return true;
    else
      return false;
  }

  runCalcForAll(event: any) {
    console.log("runCalcForAll() called");
    console.log("run_all_open_flg", event.target.checked);
    if (event.target.checked) {
      this.calcRunCtrlModel.run_all_open_flg = 'Y';
      if (this.calcRunCtrlModels.length > 0)
        this.calcRunCtrlModels[0].run_all_open_flg = 'Y';
      this.show = false;
    } else {
      this.calcRunCtrlModel.run_all_open_flg = 'N';
      if (this.calcRunCtrlModels.length > 0)
        this.calcRunCtrlModels[0].run_all_open_flg = 'N';
      this.show = true;
    }
  }

  getInprogressCalRun(event: any) {
    console.log("getInprogressCalRun() called");
    if (event.target.checked) {
      this.onlineCalcService.getInprogressCalRun().subscribe(
        (response: CalcRunCtrl[]) => {
          if (response.length > 0) {
            this.ipCalrunIdList = [];
            this.inprogressCalRunIds = response;
            for (let calrunIdData of this.inprogressCalRunIds) {
              this.ipCalrunIdList.push(calrunIdData.cal_run_id);
            }
            this.calcRunCtrlModel.cal_run_id = this.ipCalrunIdList;
            this.calcRunCtrlModel.saleschannel = null;
            this.calcRunCtrlModels = [];
          }
          else
            this.notificationService.sendNotification(NotificationType.WARNING, "Inprogress ID's Are not exist");
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else {
      this.calcRunCtrlModel.cal_run_id = '';
    }

    console.log("run_all_open_flg", event.target.checked)
  }

  displayObject(obj) {
    return obj ? obj.name : null;
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.CalcResponce;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  exportExcel() { }

}
